import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class TeamMembersProfileComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR: string = ".js-ina-our-people-profile";

    private _currentContext: JQuery = $();

    public get id(): number {
        return this._currentContext.data().id as number;
    }

    private bindEvents(): void {
        this._currentContext.on("click", e => {
            e.preventDefault();

            this.emit("profile/click", this.id);
        });
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.bindEvents();
    }
}
